import React, { ReactNode } from 'react'
import { Link } from "react-router-dom";
import { Container } from 'reactstrap';
import './Breadcrumb.scss'

interface BreadCrumbProps {
    title: string
    children: ReactNode
}

interface BreadCrumbItemProps {
    name?: string,
    current?: boolean,
    to?: string
}

export const BreadCrumb: React.FC<BreadCrumbProps> = ({ title, children }) => {
    return (
        <div className="BreadCrumb my-2">
            <Container>
                <div className='d-flex'>{children}</div>
            </Container>
        </div>
    )
}

export const BreadCrumbItem: React.FC<BreadCrumbItemProps> = ({ name, current, to }) => {
    return (
        <div className={current ? "active" : ""}>
            {to ? <Link className="breadCr me-2" to={to}>{name} <i className='fas fa-chevron-right'></i></Link>
                : <span className="breadCr">{name}</span>
            }
        </div>
    )
}
